var _rect, _text, _text2, _text3, _rect2, _text4, _g, _rect3, _g2, _path, _text5, _rect4, _text6, _g3, _text7, _text8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForesightFig2IntakeMenus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1150 660",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1150,
    height: 660,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Two front doors to the same machinery")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The standard intake beside the novice intake, recreated from the skill prompt")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 118,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "EVERY SESSION STARTS HERE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 130,
    width: 500,
    height: 470,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 166,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "How would you like to work?")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 13
  }, /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 204,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "1. Interactive"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 223,
    fill: "#4A5F56"
  }, "Full collaborative session. I challenge your"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 240,
    fill: "#4A5F56"
  }, "assumptions at each step."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 274,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "2. Guided"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 293,
    fill: "#4A5F56"
  }, "Brief intake (2-3 questions), then I produce a"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 310,
    fill: "#4A5F56"
  }, "complete first draft. Best for most use cases."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 344,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "3. Auto"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 363,
    fill: "#4A5F56"
  }, "I infer everything from your prompt and produce"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 380,
    fill: "#4A5F56"
  }, "complete output in one pass, then self-evaluate."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 414,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "4. Brief"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 433,
    fill: "#4A5F56"
  }, "Short, dense output. No preamble, no self-"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 450,
    fill: "#4A5F56"
  }, "evaluation unless asked."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 484,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "5. New to this"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 503,
    fill: "#4A5F56"
  }, "I'll guide you through everything in plain language."), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 520,
    fill: "#4A5F56"
  }, "No jargon, no assumptions about what you know."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 466,
    width: 476,
    height: 66,
    rx: 8,
    fill: "none",
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "4 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7C3AED",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548 499 C 578 499, 578 360, 606 360"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M606 354 l10 6 l-10 6 z",
    fill: "#7C3AED"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 620,
    y: 118,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#7C3AED",
    fontWeight: 600
  }, "WHAT OPTION 5 SEES INSTEAD OF NINE METHOD NAMES")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 130,
    width: 482,
    height: 470,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 166,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "What brings you here today?")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 13
  }, /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 202,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "1. \"What's changing?\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 220,
    fill: "#16A34A",
    fontSize: 12
  }, "(runs a Signal Scan)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 252,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "2. \"What could happen?\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 270,
    fill: "#16A34A",
    fontSize: 12
  }, "(builds Scenarios)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 302,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "3. \"I need to make a decision\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 320,
    fill: "#16A34A",
    fontSize: 12
  }, "(Investment Memo, or Scenarios + Implications)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 352,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "4. \"I want to create something\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 370,
    fill: "#16A34A",
    fontSize: 12
  }, "(an Artifact from the future, or a Forecast)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 402,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "5. \"Is my plan solid?\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 420,
    fill: "#16A34A",
    fontSize: 12
  }, "(runs a Challenge: red team, pre-mortem, wildcards)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 452,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "6. \"How do I get there?\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 470,
    fill: "#16A34A",
    fontSize: 12
  }, "(runs a Backcast from your desired future)"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 502,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "7. \"I'm just curious\""), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 520,
    fill: "#16A34A",
    fontSize: 12
  }, "(a Forecast + Artifact demo, then the explanation)"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 570,
    fontSize: 12,
    fill: "#6B7F74"
  }, "Each option shows the underlying mode, so the user")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 586,
    fontSize: 12,
    fill: "#6B7F74"
  }, "learns the vocabulary naturally.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForesightFig2IntakeMenus);
export default __webpack_public_path__ + "static/media/foresight-fig2-intake-menus.221ef105a0d4490bb3b5b4810564e533.svg";
export { ForwardRef as ReactComponent };